import { getResolvedApiBaseUrl } from "../utils/domainConfig";

const API_BASE_URL = getResolvedApiBaseUrl(import.meta.env.VITE_API_BASE_URL || "https://api.urb99.com");

export default API_BASE_URL;
